import React from "react";
import "./Download_Today.css";
import { Link } from "react-router-dom";

function Download_Today() {
  return (
    <>
      <section className="Download_Today section_margin">
        <div className="container">
          <div className="content_holder">
            <div className="text_holder">
              <h4>Your Learning Journey Starts Free</h4>
              <h1>Download Today</h1>
            </div>

            <div className="img_text_holder">
              <h6>Download Free on</h6>
              <div className="store_img_holder">
                <Link
                  to={
                    "https://play.google.com/store/apps/details?id=com.my_mds&pcampaignid=web_share"
                  }
                  target="_blank"
                >
                  <div className="img_holder">
                    <img
                      src="/assets/images/play_store/google_play.png"
                      alt="google play"
                      className="store_img"
                    />
                  </div>
                </Link>
                <Link
                  to={"https://apps.apple.com/us/app/my-mds/id6761702700"}
                  target="_blank"
                >
                  <div className="img_holder">
                    <img
                      src="/assets/images/play_store/app_store.png"
                      alt="app store"
                      className="store_img"
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Download_Today;
